import DisplacementEffect from "../../../assets/images/displacement-liquid.png";
import Chess from "../../../assets/images/chess.jpg";
import OnlineShop from "../../../assets/images/onlineShop.jpg";
import Portfolio from "../../../assets/images/portfolio.jpg";
import Backgammon from "../../../assets/images/backgammon.png";
import LinearEquations2 from "../../../assets/images/linear_equations.png";
import Aeropage from "../../../assets/images/aeropage_small.png";
import DynamicHtml from "../../../assets/images/dynamic_html.jpg";
import Medai from "../../../assets/images/medai_chat.png";
// import Medai from "../../assets/images/medai.png";

export default {
  Chess,
  Portfolio,
  OnlineShop,
  DisplacementEffect,
  Backgammon,
  LinearEquations2,
  Aeropage,
  DynamicHtml,
  Medai,
};
